export function abbr(value: string): string {
  const matches = value.match(/\b(\w)/g);
  const name = matches!.join('').toLocaleUpperCase();
  return name;
}
